<template>
  <modal name="yagiprimefontpayment-dialog" :adaptive="true" :scrollable="true" height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeFontpaymentDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem;"
        type="text"></el-button>
    </div>

    <!--ポップアップ-->
    <div class="setting" v-if="permissionType == 1">
      <div class="prime-font-popup">
        <h2 class="p-h2">ヤギプライム登録でフォントを切り替え</h2>
        <ul class="pc-list pc-list01">
          <li class="renew2_flex renew2_sp_flex pc-item">
            <p class="item-left">フォント利用</p>
            <p class="item-right">ヤギプライム加入特典</p>
          </li><!---->
          <li v-if="isCampaign && paymentMethodTab == 'card'" class="renew2_flex renew2_sp_flex pc-item">
            <p class="item-left">お支払い金額（税込）</p>
            <p class="item-right item-amount" style="text-decoration: line-through;margin-bottom: 0;"><span>月額
              </span>550<span>円</span></p>
            <p class="item-right item-amount"><span>7日間 </span>0<span>円</span></p>
          </li>
          <li v-else class="renew2_flex renew2_sp_flex pc-item">
            <p class="item-left">お支払い金額（税込）</p>
            <p class="item-right item-amount"><span>月額 </span>550<span>円</span></p>
          </li><!----><!---->
          <li class="pc-item">
            <p class="item-txt pc-memo">※Yagishの<a href="/terms" target="_blank" class="pc-attention">利用規約</a>、<a
                href="https://www.yagish.jp/privacy/" target="_blank" class="pc-attention">個人情報保護方針</a>、ヤギプライムの<a
                href="/yagiprimeterms" target="_blank" class="pc-attention">利用規約</a>をご確認ください。</p>
            <p class="item-txt pc-memo">※フォントの利用はヤギプライム登録期間中のみになります。ヤギプライム解除後はフォントの利用ができなくなるのでご注意ください。</p>
            <p class="item-txt pc-memo">※ヤギプライムについての説明は<a href="/yagiprimeinfo" target="_blank"
                class="pc-attention">こちら</a>をご確認ください。</p>
          </li>
        </ul>
        <PaymentForm :serviceName="serviceName" :price="price" :is_subscription="true" />
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 150%;">ヤギプライムサービス購入完了</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">

          </p>
        </div>
        <p class="thanks-txt">
          ヤギプライム会員にご登録ありがとうございます！</p>
        <p style="text-align:left;" class="note-txt">ヤギプライムへのお支払いが完了しました。早速、ヤギプライムの機能を使ってみましょう！</p>
        <div class="prime-btnblock">
          <a href="/yagiprime/info" class="prime-btn">続けて希望条件を設定する</a>
        </div>
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0;">
          <li>※フォントの切り替え方法については<a href="/fontservicehelp" target="_blank">こちら</a>をご確認ください。</li>
        </ul>
      </div>
    </div>
    <div class="text-right">
      <el-button @click="closeFontpaymentDialog">閉じる</el-button>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<!-- <style lang="scss" src="@/assets/scss/pages/setting.scss"></style> -->
<style lang="scss" scoped>
.prime-btnblock {
  text-align: center;
}

.prime-btn {
  display: block;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  background: #004d40;
  width: 250px;
  margin: 0 auto;
  border-radius: 50px;
  padding: 10px 0;
}
</style>

<style scoped>
.prime-font-popup .p-h2 {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 10px;
}

.prime-font-popup .p-h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  border: none;
}

.prime-font-popup .pc-list {
  background: #edf5e8;
  border-radius: 5px;
  padding: 15px 20px;
  margin-left: 0;
  margin-bottom: 15px;
  /*height: 135px;
        overflow-y: scroll;*/
}

.prime-font-popup .pc-item {
  justify-content: space-between;
  align-items: flex-end;
}

.prime-font-popup .item-left {
  font-weight: bold;
}

.prime-font-popup .item-amount {
  color: #e3165c;
  font-size: 18px;
  font-weight: 700;
}

.prime-font-popup .item-amount span {
  font-size: 16px;
  text-decoration: none;
}

.prime-font-popup .item-txt {
  font-size: 12px;
}

.prime-font-popup .pc-attention {
  color: red;
}

.prime-font-popup .pc-memo:first-child {
  margin-top: 10px;
}

.prime-font-popup .cv-block {
  text-align: center;
  margin-top: 15px;
}

.prime-font-popup .cv-txt {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.prime-font-popup .cv-lead {
  font-size: 12px;
  margin-bottom: 10px;
}

.prime-font-popup .consent-icon {
  width: auto;
  height: 16px;
  object-fit: cover;
  margin-right: 5px;
}

.prime-font-popup .font-payment-btn {
  position: relative;
  display: inline-block;
  background: #e3165c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  padding: 15px 0;
  border-radius: 10px;
}

.prime-font-popup .yagiprime_attention {
  margin-left: 0;
  margin-bottom: 30px;
  border-radius: 5px;
  padding: 15px 20px;
  background: #fff;
  border: 1px solid #dfdfdf;
  color: #404040;
  height: 150px;
  overflow-y: scroll;
  opacity: .8;
}
</style>
<style scoped>
.prime-font-popup .p-h2 {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 10px;
}

.prime-font-popup .p-h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  border: none;
}

.prime-font-popup .pc-list {
  background: #edf5e8;
  border-radius: 5px;
  padding: 15px 20px;
  margin-left: 0;
  margin-bottom: 15px;
  /*height: 135px;
        overflow-y: scroll;*/
}

.prime-font-popup .pc-item {
  justify-content: space-between;
  align-items: flex-end;
}

.prime-font-popup .item-left {
  font-weight: bold;
}

.prime-font-popup .item-amount {
  color: #e3165c;
  font-size: 18px;
  font-weight: 700;
}

.prime-font-popup .item-amount span {
  font-size: 16px;
  text-decoration: none;
}

.prime-font-popup .item-txt {
  font-size: 12px;
}

.prime-font-popup .pc-attention {
  color: red;
}

.prime-font-popup .pc-memo:first-child {
  margin-top: 10px;
}

.prime-font-popup .cv-block {
  text-align: center;
  margin-top: 15px;
}

.prime-font-popup .cv-txt {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.prime-font-popup .cv-lead {
  font-size: 12px;
  margin-bottom: 10px;
}

.prime-font-popup .consent-icon {
  width: auto;
  height: 16px;
  object-fit: cover;
  margin-right: 5px;
}

.prime-font-popup .font-payment-btn {
  position: relative;
  display: inline-block;
  background: #e3165c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  padding: 15px 0;
  border-radius: 10px;
}

.prime-font-popup .yagiprime_attention {
  margin-left: 0;
  margin-bottom: 30px;
  border-radius: 5px;
  padding: 15px 20px;
  background: #fff;
  border: 1px solid #dfdfdf;
  color: #404040;
  height: 150px;
  overflow-y: scroll;
  opacity: .8;
}
</style>
<script>

import { StripeElementCard } from '@vue-stripe/vue-stripe'
import PaymentForm from './Payment/PaymentMethodSelector.vue'

export default {
  components: {
    StripeElementCard,
    PaymentForm
  },
  data: function () {
    return {
      isPaymentYagiprime: true,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isFontpaymentSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      paypayurl: '',
      merchant_payment_id: '',
      isAgree: false,
      paymentMethodTab: 'card',
      isCampaign: false,
      isCampaign4Me: false,
      trial_campaign_id: 0,
      serviceName: 'ヤギプライム',
      price: 550
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      //console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed');
      }
    })
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    openFontpaymentDialog: function (id) {
      this.formatid = id
      this.$modal.show('yagiprimefontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.authStateChanged()

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'yagiprimefontpayment_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed');
        }
      })
    },
    tokenCreated (token, merchant_payment_id = '') {
      const app = this
      app.$eventHub.$emit('loading_on')
      this.token = ""
      if (token) {
        this.token = token.id
      }
      if (merchant_payment_id) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      if (app.isCampaign) {
        formData.append('trial_campaign_id', app.trial_campaign_id)
      }
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.status);

          if (response.status == 201) {
            app.$globalVar.isYagiPrime = true
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            const subformData = new FormData()
            subformData.append('route', 'fontservice')
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })


            app.registerComple = true
            app.permissionType = 2
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    closeFontpaymentDialog: function () {
      this.$modal.hide('yagiprimefontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    sendFontpayment: async function () {
      this.fullscreenLoading = true
      if (this.isPaymentYagiprime) {
        this.isPaymentYagiprime = false
        this.$refs.stripeCardElememt.submit()

      }
    },
    yagiprimePaypay: function (param) {
      const app = this
      app.fullscreenLoading = true

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('route', 'rirekisho_ai_career')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)
      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url);
          location.href = response.data.authorization_url
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    authStateChanged: async function () {
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          if (response.data.is_subscribed) {
            app.$message({
              message: 'すでにヤギプライム登録中です。',
              type: 'success'
            })
            app.$modal.hide('yagiprimefontpayment-dialog')
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.canUseTrialCampaign, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.can_use_trial_campaign)
          if (response.data.can_use_trial_campaign) {
            app.isCampaign4Me = true
          } else {
            app.isCampaign4Me = false
            app.isCampaign = false
            app.trial_campaign_id = null
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {
    const app = this

    this.$axios
      .get(this.$varuna.endPoints.getTrialCampaign, null, { timeout: 60000 })
      .then(function (response) {
        console.error(app.isCampaign)
        console.error(response.data[0])
        const today = new Date(); // 本日の日付
        const startDate = new Date(response.data[0].trial_campaign_start_date)
        const endDate = new Date(response.data[0].trial_campaign_end_date)

        // キャンペーンが有効かつ、本日がキャンペーン期間内かを確認
        if (response.data[0].trial_campaign_is_active && today >= startDate && today <= endDate) {
          app.isCampaign = true
          app.trial_campaign_id = response.data[0].trial_campaign_id
        }
        console.error(app.isCampaign)

      })
      .catch(function (error) {

      }).finally(function () {
        app.fullscreenLoading = false
      })
  },
  beforeMount: function () {
    this.$eventHub.$on('open-yagiprimefontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$on('open-fontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$on('popstate', this.closeFontpaymentDialog)
    this.$eventHub.$on('loading_on', () => {
      this.fullscreenLoading = true
    })
    this.$eventHub.$on('payment_yagiprime_result', (result) => {
      this.fullscreenLoading = false
      if (result === 'error') {
        this.$message({
          message: '決済失敗しました',
          type: 'error'
        })
      } else if (result === 'success') {
        this.$message({
          message: '決済完了しました',
          type: 'success'
        })
        location.reload()
      }
    })
    this.$eventHub.$on('loading_off', () => {
      this.fullscreenLoading = false
    })
  },
  destroyed: function () {
    this.$eventHub.$off('open-yagiprimefontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$off('open-fontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$off('popstate', this.closeFontpaymentDialog)
    this.$eventHub.$off('loading_on', () => {
      this.fullscreenLoading = true
    })
    this.$eventHub.$off('payment_yagiprime_result', (result) => {
      this.fullscreenLoading = false
      if (result === 'error') {
        this.$message({
          message: '決済失敗しました',
          type: 'error'
        })
      } else if (result === 'success') {
        this.$message({
          message: '決済完了しました',
          type: 'success'
        })
        location.reload()
      }
    })
    this.$eventHub.$off('loading_off', () => {
      this.fullscreenLoading = false
    })
  }
}
</script>
